interface IRealEstateGGoalsDetailsProps {
  step2: {
    q1: string;
    q2: string;
    interestedProperties: any[];
    "q1-interestedPropertyDetail"?: string;
  };
}
export default function RealEstateGoalsDetails({
  step2,
}: IRealEstateGGoalsDetailsProps) {
  return (
    <>
      <section aria-labelledby="applicant-information-title">
        <div className="bg-white shadow sm:rounded-lg">
          <div className="py-5">
            <div className="px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal">
              <h2
                id="applicant-information-title"
                className="m-0 text-lg leading-6 font-medium text-primaryColor-normal"
              >
                Real Estate Goals
              </h2>
            </div>
          </div>
          <div className="border-t border-gray-200 px-4 py-5 sm:px-6 flex flex-col gap-6">
            <div className="space-y-2">
              <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
                <div className="sm:col-span-2">
                  <dt className="text-sm font-medium text-gray-500">
                    Property Identified
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 capitalize">
                    {step2?.q1}
                  </dd>
                </div>
                {step2?.q1 === "yes" && (
                  <div className="space-y-2 col-span-2">
                    <h3 className="mt-1 max-w-2xl ">
                      List of interested properties
                    </h3>
                    <dl className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2">
                      {step2?.interestedProperties?.map((ip) => (
                        <div className="sm:col-span-1">
                          <dt className="text-md font-semibold text-neutralColor-medium">
                            {ip.propertyStatus}
                          </dt>
                          <dd className="mt-1 text-sm text-gray-500 flex flex-col">
                            <span>
                              {ip.streetAddress}, {ip.city}, {ip.state},{" "}
                              {ip.zipCode}
                            </span>
                            <span>Municipality: {ip.municipality}</span>
                            <span>
                              Preliminary plan to utilize this land:{" "}
                              {ip.landUtilizationPlan}
                            </span>
                            <span>Property type: {ip.propertyType}</span>
                            <span>
                              {" "}
                              Outstanding code violations/municipal liens:{" "}
                              {ip.codeViolation}
                            </span>
                            <span>
                              Talked with CDC/RCO to confirm property
                              availability: {ip.confirmProperty}
                            </span>
                            <span>
                              Current Condition of property:{" "}
                              {ip.propertyCurrentCondition}
                            </span>
                            <span>Property Taxes: {ip.propertyTaxes}</span>
                            <span>Water Bills: {ip.waterBills}</span>
                            <span>Sewage Bills: {ip.sewageBills}</span>
                            <span>Refuse Bills: {ip.refuseBills}</span>
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                )}
                {step2?.q1 === "no" && (
                  <div className="sm:col-span-1">
                    <dt className="text-sm font-medium text-gray-500">
                      More about the property
                    </dt>
                    <dd className="mt-1 text-sm text-gray-900">
                      {step2["q1-interestedPropertyDetail"]}
                    </dd>
                  </div>
                )}
                <div className="sm:col-span-2">
                  <dt className="text-sm font-medium text-gray-500">
                    Interested in a property that directly borders land you
                    already own
                  </dt>
                  <dd className="mt-1 text-sm text-gray-900 capitalize">
                    {step2?.q2}
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
